import {addGtAccessRecord,getIp} from "@/api/index"
export function scrollByRef(refName) {
    window.scrollTo({
        top: this.$refs[refName].offsetTop-162,
        behavior: "smooth"
      })
  }

  export const setStore = (params = {}) => {
    let {
        name,
        content,
    } = params;
    let obj = {
        dataType: typeof (content),
        content: content,
        datetime: new Date().getTime()
    }
    window.localStorage.setItem(name, JSON.stringify(obj));
}
/**
 * 获取localStorage
 */

export const getStore = (params = {}) => {
    let {
        name
    } = params;
    let obj = {},
        content;
    obj = window.localStorage.getItem(name);
    try {
        obj = JSON.parse(obj);
    } catch{
        return obj;
    }
    if (obj.dataType == 'string') {
        content = obj.content;
    } else if (obj.dataType == 'number') {
        content = Number(obj.content);
    } else if (obj.dataType == 'boolean') {
        content = eval(obj.content);
    } else if (obj.dataType == 'object') {
        content = obj.content;
    }
    return content;
}

// 获得导航栏
export function getNavListByType(type,index,detial){
    let AllBreadList={
        news:[{
        title: '首页',
        url:'/'
    }, {
        title: '新闻动态',
        url:'/news'
    }, {
        title: ''
    }],
        orga:[{
            title: '首页',
            url:'/'
        }, {
            title: '组织建设',
            url:'/organizational'
        }, {
            title: ''
        }],
        bussiness:[{
            title: '首页',
            url:'/'
        }, {
            title: '业务领域',
            url:'/bussiness'
        }, {
            title: ''
        }],
        honor:[{
            title:'首页',
            url:'/'
        },{
            title:'中心概况',
            url:'/overview/?to='+index
        },{
            title:'荣誉与成就详情',
        }]
    }
    if(type=='honor'){
        let temp=AllBreadList[type]
        return {list:temp,name:temp[temp.length-1].title}
    }else{
        let AllScrollList={
            news:['中心资讯','最新新闻','行业动态','通知公告'],
            orga:['党群动态','党建活动','培训学习'],
            bussiness:['产品与服务','技术与创新','行业动向'],
        }
        let temp=AllBreadList[type]
        temp[temp.length-1].title=AllScrollList[type][index]
        
        if(detial){
            let nameObj={
                news:'新闻详情',
                orga:'组织建设详情',
                bussiness:'业务领域详情'
            }
            let detailName=nameObj[type]
                temp.push({title:detailName})
            // }
            return {list:temp,name:temp[temp.length-1].detailName}
        }else{
            return {list:temp,name:temp[temp.length-1].title}
        }
    }
}
// 计算浏览量
export function countViewCount(){
    let params={
        type:IsPC()?1:2
    }
    // getIp().then(res=>{
    //     let temp=res||{}
    //     params.accessIp=(temp.ip)?(temp.ip):null
        addGtAccessRecord(params)
    // }).catch(err=>{
    //     params.accessIp=null
        // addGtAccessRecord(params)
    // })
    // addGtAccessRecord({type:IsPC()?1:2})
}   

export function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
          "SymbianOS", "Windows Phone",
          "iPad", "iPod"]
    var flag = true;
    for (var v = 0; v < Agents.length;v++) {
      if (userAgentInfo.indexOf(Agents[v]) >= 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }
// 替换

export function  replaceKeywordColor(val,keyword,color) {
    if (val&&val!=''&&val.includes(keyword) && keyword != '') {
        let regExp = new RegExp(keyword, 'g');
        return val.replace(
            regExp,
            `<font color="${color}">` + keyword + '</font>'
        )
    } else {
        return val
    }
}